import { TDishAssignmentAction, DishAssignmentActionTypes } from './dishAssignmentActions';
import { IDishAssignmentState } from './dishAssignmentContext';

export const dishAssignmentReducer = (
	state: IDishAssignmentState,
	action: TDishAssignmentAction,
): IDishAssignmentState => {
	switch (action.type) {
		case DishAssignmentActionTypes.SET_DISHES_FOR_ASSIGN:
			return {
				...state,
				dishesForAssign: action.payload.dishesForAssign,
			};
		case DishAssignmentActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				IDsSelectedDishes: [],
				currentPage: 1,
			};
		case DishAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_CATEGORIES:
			return {
				...state,
				searchStringForCategories: action.payload.searchStringForCategories,
			};
		case DishAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_SUBCATEGORIES:
			return {
				...state,
				searchStringForSubcategories: action.payload.searchStringForSubcategories,
			};
		case DishAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_DISHES:
			return {
				...state,
				searchStringForDishes: action.payload.searchStringForDishes,
			};
		case DishAssignmentActionTypes.SET_ID_SELECTED_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				fetchedRestaurants: [],
				IDSelectedRestaurant: null,
				price: '',
				IDsSelectedDishes: [],
				isUnassignedDishes: false,
				currentPage: 1,
				searchString: '',
			};
		case DishAssignmentActionTypes.SET_FETCHED_RESTAURANTS:
			return {
				...state,
				fetchedRestaurants: action.payload.restaurants,
			};
		case DishAssignmentActionTypes.SET_ID_SELECTED_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				price: '',
				IDsSelectedCategories: {},
				categories: [],
				IDsSelectedSubcategories: {},
				subcategories: [],
				IDsSelectedDishes: [],
				isUnassignedDishes: false,
				dishes: [],
				activeItemToDisplay: 'categories',
				currentPage: 1,
			};
		case DishAssignmentActionTypes.SET_PRICE:
			return {
				...state,
				price: action.payload.price,
				IDsSelectedDishes: [],
				isUnassignedDishes: false,
				currentPage: 1,
			};
		case DishAssignmentActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				fetchedRestaurants: [],
				IDSelectedRestaurant: null,
				price: '',
				isUnassignedDishes: false,
				IDsSelectedDishes: [],
				currentPage: 1,
			};
		case DishAssignmentActionTypes.CHANGE_UNASSIGNED_DISHES_STATUS:
			return {
				...state,
				isUnassignedDishes: action.payload.isUnassignedDishes,
				IDsSelectedDishes: [],
				currentPage: 1,
			};
		case DishAssignmentActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				IDsSelectedDishes: [],
			};
		case DishAssignmentActionTypes.SET_IDS_SELECTED_DISHES:
			return {
				...state,
				IDsSelectedDishes: action.payload.IDsSelectedDishes,
			};
		case DishAssignmentActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
				IDsSelectedDishes: [],
			};
		case DishAssignmentActionTypes.SET_CATEGORIES:
			return {
				...state,
				IDsSelectedCategories: {},
				categories: action.payload.categories,
				notificationsForCategory: action.payload.notificationsForCategory,
				IDsSelectedSubcategories: {},
				subcategories: [],
				IDsSelectedDishes: [],
				dishes: [],
			};
		case DishAssignmentActionTypes.SET_IDS_SELECTED_CATEGORIES:
			return {
				...state,
				IDsSelectedCategories: action.payload.IDsSelectedCategories,
				subcategories: action.payload.subcategories,
				IDsSelectedSubcategories: action.payload.IDsSelectedSubcategories,
				dishes: action.payload.dishes,
			};
		case DishAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY:
			return {
				...state,
				activeItemToDisplay: action.payload.activeItemToDisplay,
			};
		case DishAssignmentActionTypes.TOGGLE_SHOW_BREADCRUMBS:
			return {
				...state,
				isShowBreadcrumbs: action.payload.isShowBreadCrumbs,
			};
		case DishAssignmentActionTypes.SET_IDS_SELECTED_SUBCATEGORIES:
			return {
				...state,
				IDsSelectedSubcategories: action.payload.IDsSelectedSubcategories,
				dishes: action.payload.dishes,
			};
		case DishAssignmentActionTypes.SET_DISHES:
			return {
				...state,
				dishes: action.payload.dishes,
				IDsSelectedDishes: action.payload.IDsSelectedDishes,
			};
		case DishAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case DishAssignmentActionTypes.CHANGE_IS_SHOW_MODAL_WINDOW_TO_CREATE_SUBCATEGORY:
			return {
				...state,
				isShowModalWindowToCreateSubcategory: action.payload.isShowModalWindowToCreateSubcategory,
			};
		case DishAssignmentActionTypes.RESET_CHANGES:
			return {
				...state,
				IDsSelectedCategories: {},
				IDsSelectedSubcategories: {},
				subcategories: [],
				IDsSelectedDishes: [],
				dishes: [],
				activeItemToDisplay: 'categories',
				typeOfModalWindow: null,
			};
		case DishAssignmentActionTypes.SET_VISIBLE_ADDITIONAL_RESTAURANTS_MODAL:
			return {
				...state,
				isVisibleAdditionalRestaurantsModal: action.payload.isVisible,
				isApplyToOne: action.payload.isVisible ? false : action.payload.isVisible,
				selectedAdditionalRestaurants: action.payload.isVisible ? [] : state.selectedAdditionalRestaurants,
				selectSearchString: action.payload.isVisible ? '' : state.selectSearchString,
			};
		case DishAssignmentActionTypes.TOGGLE_APPLY_TO_ONE:
			return {
				...state,
				isApplyToOne: !state.isApplyToOne,
				selectedAdditionalRestaurants: [],
			};
		case DishAssignmentActionTypes.SET_ADDITIONAL_RESTAURANTS:
			return {
				...state,
				selectedAdditionalRestaurants: action.payload.additionalRestaurants,
			};
		case DishAssignmentActionTypes.CHANGE_SELECT_SEARCH_STRING:
			return {
				...state,
				selectSearchString: action.payload.selectSearchString,
			};
		default:
			return state;
	}
};
